import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import styled from 'styled-components';
import TextInput from '../atoms/textinput.jsx';
import Button from '../atoms/button.jsx';
import { Label } from '../atoms/label.jsx';
import { COLOR, SIZE, KEY, LABEL, SCREEN_MEDIA, FONT_FAMILY } from '../../utils/constants.js';
import { useLogin } from '../hooks/useLogin.js';
import { useAuth } from '../../utils/authDispatcher.js';
import LoadingSpinner from '../organism/spinner.jsx';

const Container = styled.div`
    overflow: auto; // To cover height with contents
    padding: 20px;
    @media only screen and ${SCREEN_MEDIA.small} {
        margin: 30px 60px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        margin: 30px 150px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        margin: 30px 300px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        margin: 30px 400px;
    }
`;

const BodyLogin = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [credentials, setCredentials] = useState({ user: '', password: '' });
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const loginResult = useLogin(isLoginLoading, credentials);

    const from = location.state?.from?.pathname || "/";

    const { login } = useAuth();

    console.log(`from: ${from}`)

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleLogin = (e) => {
        e.preventDefault();
        setIsLoginLoading(true)
    };

    useEffect(() => {
        if (loginResult && loginResult.success !== undefined) {
            setIsLoginLoading(false)
            if (loginResult.success) {
                login({ name: credentials.user });
                navigate(from, { replace: true });
            } else {
                alert('Wrong credentials');
            }
        }
    }, [loginResult]);

    if (isLoginLoading) return <LoadingSpinner/>;

    return (
        <Container>
            <form onSubmit={ handleLogin }>
            <TextInput 
                id='user'
                name='user'
                type='text' 
                placeholder='usuario'
                margin='0 0'
                onChange={ handleChange }/>
            <TextInput 
                id='password'
                name='password'
                type='password' 
                placeholder='contraseña'
                margin='0 0'
                onChange={ handleChange }/>
            <Button
                type='submit'
                width='120px'
                height='46px'
                bg_color={ COLOR.black }
                margin='10px 0 0 0'
                float='right'
                onChange={ () => {} }>
                <Label
                    text_color={ COLOR.white }
                    text_size={SIZE.subtitle}
                    font_family={FONT_FAMILY.avenirMedium}
                    margin='auto'>
                    {LABEL.send}
                </Label>
            </Button>
            </form>
        </Container>
    )

}

export default BodyLogin;